export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  resourceCount: number;
  colorClass: string;
}

export const categories: Category[] = [
  {
    slug: 'free-paper-db',
    name: '免费论文数据库',
    description: '汇聚全球知名免费学术论文数据库，涵盖SCI、SSCI、EI等核心期刊资源，提供全文下载与文献检索服务',
    icon: 'ri-database-2-line',
    resourceCount: 86,
    colorClass: 'bg-amber-100 text-amber-700',
  },
  {
    slug: 'download-tools',
    name: '文献下载工具',
    description: '精选高效文献下载工具与插件，支持多平台学术资源一键获取，让文献查找不再困难',
    icon: 'ri-download-cloud-2-line',
    resourceCount: 54,
    colorClass: 'bg-emerald-100 text-emerald-700',
  },
  {
    slug: 'journals',
    name: '学术期刊导航',
    description: '整理国内外顶级学术期刊入口，覆盖自然科学、社会科学、工程技术等各学科领域',
    icon: 'ri-book-open-line',
    resourceCount: 120,
    colorClass: 'bg-rose-100 text-rose-700',
  },
  {
    slug: 'research-benefits',
    name: '科研福利资源',
    description: '汇集各大平台科研专属福利、教育优惠、免费软件许可、云服务器额度等学术特权',
    icon: 'ri-gift-line',
    resourceCount: 42,
    colorClass: 'bg-violet-100 text-violet-700',
  },
  {
    slug: 'open-access',
    name: '开源学术平台',
    description: '收录全球优质开源学术平台与预印本服务，推动开放科学理念，促进学术成果自由传播',
    icon: 'ri-open-source-line',
    resourceCount: 68,
    colorClass: 'bg-cyan-100 text-cyan-700',
  },
  {
    slug: 'writing-tools',
    name: '学术写作辅助',
    description: '推荐论文排版、参考文献管理、语法校对、查重降重等学术写作全流程工具',
    icon: 'ri-edit-2-line',
    resourceCount: 73,
    colorClass: 'bg-orange-100 text-orange-700',
  },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});